import { useState, useEffect } from "react";
import { useForm } from "react-hook-form";
import { useQueryClient } from "@tanstack/react-query";
import Button from "../common/Button";
import Input from "../common/Input";
import { teamService } from "../../services/team";
import toast from "react-hot-toast";

const MemberForm = ({ member, onSuccess }) => {
  const {
    register,
    handleSubmit,
    reset,
    formState: { errors },
  } = useForm({
    defaultValues: member || {},
  });
  const [loading, setLoading] = useState(false);
  const queryClient = useQueryClient();

  useEffect(() => {
    reset(member || {});
  }, [member, reset]);

  const onSubmit = async (data) => {
    setLoading(true);
    try {
      if (member) {
        await teamService.update(member._id, data);
        toast.success("Member updated");
      } else {
        await teamService.create(data);
        toast.success("Member created");
      }
      queryClient.invalidateQueries({ queryKey: ["team"] });
      reset();
      onSuccess();
    } catch (error) {
      toast.error(error.response?.data?.message || "Error");
    } finally {
      setLoading(false);
    }
  };

  return (
    <form onSubmit={handleSubmit(onSubmit)} className="space-y-4">
      <Input
        label="Name"
        {...register("name", { required: "Name is required" })}
        error={errors.name?.message}
      />
      <Input
        label="Email"
        type="email"
        {...register("email", { required: "Email is required" })}
        error={errors.email?.message}
      />
      <Input
        label={member ? "Password (leave blank to keep current)" : "Password"}
        type="password"
        {...register("password", {
          required: !member && "Password is required",
        })}
        error={errors.password?.message}
      />
      <Input
        label="Phone"
        {...register("phone")}
        error={errors.phone?.message}
      />
      <select {...register("role")} className="border rounded p-2">
        <option value="executive">Executive</option>
        <option value="manager">Manager</option>
        <option value="admin">Admin</option>
      </select>
      <Button type="submit" disabled={loading}>
        {loading ? "Saving..." : member ? "Update" : "Create"}
      </Button>
    </form>
  );
};

export default MemberForm;
